module.exports = __webpack_public_path__ + "static/media/Pasted Graphic 10.47801b79.png";